import campaignsTemplate from './campaigns.html';
import campaignAddTemplate from './campaignAdd.html';
import campaignDetailTemplate from './campaignDetail.html';
import campaignContactDetailTemplate from './campaignContactDetail.html';
import motherCampaignAddTemplate from './motherCampaignAdd.html';

/* @ngInject */
const CampaignsConfig = ($stateProvider) => {
    $stateProvider
        .state('campaigns', {
            url: '/campaigns?type',
            template: campaignsTemplate,
            controller: 'CampaignsController',
            controllerAs: 'campaigns',
            params: { campaignType: 'CAMPAIGN' },
        })
        .state('motherCampaignAdd', {
            url: '/campaigns/add/mother',
            template: motherCampaignAddTemplate,
            controller: 'motherCampaignAddController',
            controllerAs: 'campaignAdd',
        })
        .state('motherCampaignEdit', {
            url: '/mother-campaigns/edit/:campaignId',
            template: motherCampaignAddTemplate,
            controller: 'motherCampaignAddController',
            controllerAs: 'campaignAdd',
        })
        .state('campaignAdd', {
            url: '/campaigns/add?type',
            template: campaignAddTemplate,
            controller: 'CampaignAddController',
            controllerAs: 'campaignAdd',
        })
        .state('campaignEdit', {
            url: '/campaigns/edit/:campaignId',
            template: campaignAddTemplate,
            controller: 'CampaignAddController',
            controllerAs: 'campaignAdd',
        })
        .state('campaignContactDetail', {
            url: '/campaigns/:campaignId/contacts/:contactId',
            template: campaignContactDetailTemplate,
            controller: 'CampaignContactDetailController',
            controllerAs: 'campaignContact',
        })
        .state('campaignDetail', {
            url: '/campaigns/:campaignId/:sortOrder/:level',
            template: campaignDetailTemplate,
            controller: 'CampaignDetailController',
            controllerAs: 'campaign',
        });
};

export default CampaignsConfig;



/** WEBPACK FOOTER **
 ** ./src/app/components/campaigns/campaigns.config.js
 **/